// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useQuery } from '@tanstack/react-query';
import { getLandingPage } from '@api/portalServices';
import type { GetLandingPageResponse } from '@api/types';
import { useSession } from '@common/authorization/context/Session';
import { QueryKey } from '@portal/constants';

export const useLandingPage = () => {
  const { workflowId, tenantId } = useSession();
  return useQuery<GetLandingPageResponse>({
    queryKey: [QueryKey.LANDING_PAGE, tenantId, workflowId],
    queryFn: () => getLandingPage(workflowId ?? '', tenantId ?? ''),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
